export const yacanConfig = {
  connection: {
    title: "الاتصال بـ YACAN",
    subtitle: "اربط حساب YACAN الخاص بك لإدارة دخول ضيوفك عبر أقفالك.",
    connected: "الحساب متصل",
    notConnected: "غير متصل",
    info:
      "عند النقر على <b>الاتصال بـ YACAN</b> ستُفتح نافذة لتسجيل الدخول والسماح بالوصول. يُحفظ الاتصال لحسابك بالكامل ويُستخدم في جميع عقاراتك.",
    connect: "الاتصال بـ YACAN",
    waiting: "بانتظار التفويض...",
    connectedTitle: "حساب YACAN متصل",
    authActive: "التفويض نشط",
    reauthorize: "إعادة التفويض",
    reauthorizeTitle: "التفويض من جديد",
    disconnect: "قطع الاتصال",
  },
  locks: {
    title: "الأقفال الخاصة بهذا العقار",
    subtitle: "حدِّد أقفال YACAN التي تنطبق على <b>هذا العقار</b>.",
    selectedCount: "{count} محدَّد",
    noneFound: "لم يُعثر على أي أقفال في حساب YACAN الخاص بك.",
    refresh: "تحديث",
    placeholder: "حدِّد الأقفال…",
    summary: "{count} قفل محدَّد",
    empty: "لم يتم تحديد أي قفل",
    lockFallback: "قفل {id}",
    save: "حفظ أقفال هذا العقار",
    saving: "جارٍ الحفظ...",
  },
  assign: {
    title: "التعيين (PMS)",
    subtitle:
      "عيِّن كل قفل إلى <b>الباب الرئيسي</b> أو <b>وحدة</b> أو <b>بوابة</b>.",
    assignedCount: "{count} معيَّن",
    info:
      "مع YACAN، <b>يُدير YACAN دخول الضيف</b> بناءً على الحجز: لا تُنشأ رموز PIN من هنا. وعند تأكيد الحجز، تتم المزامنة تلقائيًا مع YACAN.",
    lockFallback: "قفل {id}",
    assignmentLabel: "التعيين",
    typeNone: "غير معيَّن",
    typeCommon: "الباب الرئيسي (مشترك)",
    typeUnit: "باب الشقة",
    typeGate: "بوابة / مرآب",
    unitLabel: "الوحدة / مكان الإقامة",
    unitPlaceholder: "حدِّد وحدة",
    unitFallback: "وحدة {id}",
    save: "حفظ التعيين",
    saving: "جارٍ الحفظ...",
  },
  msg: {
    connectStartError: "تعذَّر بدء الاتصال بـ YACAN",
    popupBlocked: "اسمح بالنوافذ المنبثقة للاتصال بـ YACAN.",
    connectError: "خطأ أثناء الاتصال بـ YACAN",
    connectSuccess: "تم ربط حساب YACAN بنجاح",
    connectFailed: "تعذَّر الاتصال بـ YACAN",
    disconnectConfirm:
      "هل تريد قطع الاتصال بحساب YACAN؟ ستتوقف مزامنة الحجوزات مع YACAN.",
    disconnectSuccess: "تم قطع الاتصال بحساب YACAN",
    disconnectError: "تعذَّر قطع الاتصال",
    locksLoadError: "تعذَّر تحميل الأقفال",
    locksLoadError2: "خطأ أثناء تحميل أقفال YACAN",
    selectAtLeastOne: "حدِّد قفلًا واحدًا على الأقل.",
    lockDefaultName: "قفل YACAN",
    locksSaved: "تم حفظ الأقفال لهذا العقار",
    locksSaveError: "تعذَّر حفظ الأقفال",
    saveError: "خطأ أثناء الحفظ",
    selectUnitForApartment: "حدِّد الوحدة لأقفال من نوع «باب الشقة».",
    assignSaved: "تم حفظ التعيين بنجاح",
    assignSaveError: "تعذَّر حفظ التعيين",
    assignSaveError2: "خطأ أثناء حفظ التعيين",
  },
};
